import { OverlayToaster, Intent } from '@blueprintjs/core';
import './Notifications.css';

let toasterPromise = null;

function getToaster() {
    if (!toasterPromise) {
        toasterPromise = OverlayToaster.create({
            position: "bottom-right"
        });
    }
    return toasterPromise;
}

var NotificationToastSettings = {
    danger: {
        intent: Intent.DANGER,
        icon: "warning-sign"
    },
    warning: {
        intent: Intent.WARNING,
        icon: "warning-sign"
    },
    success: {
        intent: Intent.SUCCESS,
        icon: "tick"
    }
}

export const NotificationToaster = {
    show: async (intent, message, usePortal = true) => {
        var toaster = await getToaster();
        var toastSettings = NotificationToastSettings[intent];
        if (toastSettings == null) {
            toastSettings = NotificationToastSettings[Intent.SUCCESS];
        }
        toaster.show({
            message: message,
            intent: toastSettings.intent,
            icon: toastSettings.icon,
            usePortal: usePortal
        });
    },
    clear: async () => {
        var toaster = await getToaster();
        toaster.clear();
    }
}



